import { Directive, SkipSelf } from "@angular/core";
import { IOnModelChange } from "../../common-form.interface";
import { CommonFieldManagerDirective } from "../../field-manager.directive";

@Directive({
    selector: "[common-radio-group-actions]",
    exportAs: "RadioGroupActions",
})
export class CommonRadioGroupActionsDirective implements IOnModelChange {

    constructor( @SkipSelf() public fieldManager: CommonFieldManagerDirective) { }

    public onModelChange(state, ...args) {
        const index: number = args[0];
        this.fieldManager.dispatchFieldUpdate(state, index);
        this.fieldManager.dispatchFormFieldChange(state);
    }

    public clearState() {
        this.fieldManager.dispatchFieldUpdate(undefined);
        this.fieldManager.resetFieldValue();
    }
}
